<template>
  <div class="modal-card">
    <div class="row-width-actions-bar">
      <div class="columns is-gapless is-vcentered is-border-bottom">
        <div class="column is-padding-left">
          <div class="has-text-dark is-size-6 is-uppercase">
            <span class="has-text-weight-medium">Annuler procédure</span>
          </div>
        </div>
        <div class="column is-narrow is-border-left">
          <a
            class="page-header-btn is-small is-square"
            @click="close">
            <span class="icon is-size-4 has-text-dark"><i class="fal fa-times"></i></span>
          </a>
        </div>
      </div>
    </div>
    <section class="modal-card-body is-clipped">
      <div class="is-border-bottom ">
        <div class="is-padding has-text-centered">
          <span class="has-text-danger has-text-weight-medium is-size-4 is-uppercase">Souhaitez-vous vraiment annuler la procédure ?</span>
        </div>
      </div>
      <div>
        <div class="is-padding-top-small is-padding-right-small is-padding-left-small">
          <div class="is-padding-xsmall is-border-top is-border-right is-border-left">
            <span class="is-size-6">
              Vous pouvez renseigner ci-dessous les raisons de l'annulation de la procédure
            </span>
          </div>
        </div>
        <div class="is-padding-bottom-small is-padding-right-small is-padding-left-small">
          <wysiwyg-editor
            :light="true"
            :tooltip-top="true"
            :model="commentaire"
            @change="val => commentaire = val"
            class="editr--bottom-toolbar no-toolbar editr--height-small content">
          </wysiwyg-editor>
        </div>
      </div>
      <div class="columns is-gapless is-centered has-background-white is-padding-top-small is-padding-bottom-small">
        <div class="control">
          <button
            @click="close()"
            class="swal2-cancel swal2-styled"
            style="display: inline-block; width: 230px !important; height: 42px">
            <span>
              Annuler
            </span>
          </button>
        </div>
        <div class="is-padding-left control">
          <button
            type="button"
            @click="confirm()"
            class="swal2-confirm is-danger swal2-styled"
            aria-label
            style="display: inline-block; border-left-color: rgb(219, 83, 77); border-right-color: rgb(219, 83, 77); background-color: #db534d;
              border-color: transparent;
              color: #fff; width: 230px !important; height: 42px">
            <span>
              Confirmer
            </span>
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'CancelSignature',
  props: {
    active: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      commentaire: null
    }
  },
  methods: {
    confirm () {
      this.$store.commit('setCommentaire', this.commentaire)
      if (this.commentaire) {
        this.$emit('confirm', this.commentaire)
      } else {
        let params = {
          cancel: true
        }
        this.$emit('confirm', params)
      }
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>
